import React from "react";
import CompanyTotalDetails from "../../components/sections/front/CompanyTotalDetails";
import CompanyCard from "../../components/sections/front/CompanyCard";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { organizationDetailsUser } from "../../services/organizationService";
import MenuCard from "../../components/sections/front/MenuCard";

const menuItems = [
  {
    label: "Create Company",
    icon: "fa-regular fa-plus",
    link: "/manage-company",
  },
  { label: "Saved items", icon: "fa-regular fa-bookmark", link: "/post" },
  { label: "Jobs List", icon: "fa-fw fa-solid fa-briefcase", link: "/post" },
  { label: "Application", icon: "fa-regular fa-newspaper", link: "/post" },
];

const CompanyDetails = () => {
  const { slug } = useParams();

  const { data, isLoading } = useQuery({
    queryKey: ["company-details", slug],
    queryFn: async () => {
      if (!slug) return null;
      const res = await organizationDetailsUser({ slug });
      return res;
    },
    enabled: !!slug,
  });
  if (isLoading) return <div>Loading...</div>;
  if (!data?.data) return <div>No company found</div>;
  return (
    <div>
      <CompanyTotalDetails organization={data?.data} />
    </div>
  );
};

export default CompanyDetails;
